/**
 * @module recorder/recorderresize
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import RecorderResizeEditing from './recorderresize/recorderresizeediting';
import RecorderResizeHandles from './recorderresize/recorderresizehandles';
import RecorderResizeButtons from './recorderresize/recorderresizebuttons';
import './theme/recorderresize.css';

export default class RecorderResize extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [ RecorderResizeEditing, RecorderResizeHandles, RecorderResizeButtons ];
    }

    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'RecorderResize';
    }
}
